import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL, NETWORK_ERROR } from '../config';
import { setServiceMessage } from '../../helpers/helper';

const QueueService = {
    // statusName:incoming name ['IN-PROGRESS'] or  ['PENDING'] or ['COMPLETED'] ['CANCELED']
    getAutomQueueList: async function (statusName) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/queue/automation?status=` + statusName);
            return response.data;
        } catch (error) {
            return error;
        }
    },
    // statusName:incoming name ['IN-PROGRESS'] or  ['PENDING'] or ['COMPLETED'] ['CANCELED']
    // getIpaasQueueList: async function (statusName) {
    //     try {
    //         const response = await axiosApiInstance.get(BASE_URL + `/queue/ipaas?status=` + statusName);
    //         return response.data;
    //     } catch (error) {
    //         return error;
    //     }
    // },

    //Insert New Autom in Queue
    insertQueue: async function (id, mateId) {
        try {
            return await axiosApiInstance.post(BASE_URL + `/automs/insert/queue`, {
                id,
                mateId
            });
        } catch (error) {
            return error;
        }
    },
    getQueueStatus: async function (status = ["PENDING", "IN-PROGRESS"]) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/queue/automation/count?status=${JSON.stringify(status)}`);
            return response.data;
        } catch (error) {
            if (error.response) {
                return setServiceMessage(error.response.data, 'CONTENT.QUEUE.');
            } else {
                return NETWORK_ERROR;
            }
        }
    },
    // queue ActivityLog log service
    getQueueActivityLog: async function (id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + '/log' + id)
            return response.data;
        } catch (error) {
            console.log("getQueueActivitiyLog => ", error);
        }
    },
    /* update sort order service  
        * sample Data
        {
            operation_status:'pending',
            operationType:'ipaas',
            orders: [
                { id: 'asdasdasda', order: 4 },
                {id:'asda', order:5}
                ]
                ]
}       }
    */
    updateSortOrder: async function (data) {
        try {
            const response = await axiosApiInstance.put(BASE_URL + '/queue', data)
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteQueues: async function (ids) {
        try {
            const response = await axiosApiInstance.delete(BASE_URL + `/queue`, {
                data: { ids }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
};

export default QueueService;
